export interface cv_ResourceGroup {
    C_ResourceGroup_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    ResourceGroup: string;
    SortOrder: number | null;
    Version: number;
}
